 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0,
 		0: 0,
 		1: 0,
 		2: 0,
 		3: 0,
 		4: 0,
 		10: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~ContentAccessLookup~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","6":"MergeApproval~MergeRequest~UserDash","7":"News","8":"Bulk-Processing-Status","9":"MergeApproval~MergeRequest","11":"AssignmentContainer","12":"AssignmentsContainer","13":"BulkRoster","14":"ContentAccessLookup","15":"District-Report","16":"Home","17":"LazyAssignedArticleReviewContainer","18":"LazyCanvasAssignmentReviewContainer","19":"LazySearchComponent","20":"LessonSparkContainer","21":"MergeApproval","22":"MergeRequest","23":"OneRosterOrgs","24":"OpenMergeRequests","25":"ProvisionSchools","26":"Pygmalion","27":"ReadContainer","28":"StandaloneExternalEmbed","29":"StandalonePoll","30":"StandardContainer","31":"TeacherBinder","32":"TextSets","33":"UnitsContainer","34":"UserDash","35":"YourContentContainer","37":"browse","40":"vendors~ProvisionSchools","41":"vendors~browse"}[chunkId]||chunkId) + "." + {"0":"0686ff2e78ccc36deef2","1":"8368965eb47f8105cfa0","2":"a913211632ae4191f8ab","3":"706a48cb334a8ba858af","4":"ef7eeedebc9741e31717","5":"0108522ec0440165b007","6":"ddca838830133e733f41","7":"e90892507681bd7ddfc6","8":"351b10ee1d172be56eaf","9":"e13baf79384efb5c5b73","10":"b864bcbe5ab7d01e6969","11":"e47ea51deb0b3fda527e","12":"487e360330f206be654c","13":"b16171d8e863af10e352","14":"f5abc9f8d498ec67562f","15":"945348fe060337196194","16":"75fedf63596ae9797fba","17":"c46565b47e0dd33a19a8","18":"930b7961b38dc86fcc5a","19":"be4cfc9bee1cc5ab6939","20":"c7a3807e3f3d90c0a37b","21":"d149ab78acdf1a8e270a","22":"0c34be3082878e57c916","23":"49930dbea1a24d5aaa19","24":"f5391df0cacad7d2ee95","25":"57e9999263914f7be5b8","26":"c2a1bed4be6b9ee46401","27":"651d1f5115b433e63167","28":"b284002ae06996999750","29":"192cfdaa5412b9893236","30":"0ff033ff8edafa56cdc1","31":"0f5a1e28aa406b1d74ad","32":"6203d80ab32b2eef7712","33":"3c90002c0a1cad315174","34":"dff24e0718b3729d2002","35":"528824cd47198bb7e496","37":"027638cb4aafa2aecb4f","40":"01f3e0653639a75f93a4","41":"fbfff23bfed65bb4121e","42":"b9725ea3d621573c760d","43":"720b826977d648f0aa2f","44":"cbeb1c3494c6ea7a2504","45":"3c8413cfb270b3af6905","46":"f406e2d3977f0ef764a2","47":"9bd80cc2bb11bc1a34c4","48":"f2f1d80187a7e3a60f79","49":"d7033e500ff231ce8d00","50":"dc56b72c26dc7f164b32","51":"08d053a72c643f3b94d6","52":"cb42db71781259a16bd5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1609);
